import { getCheckInLikers } from '@/api/endpoints/activity';
import { FEED_QUERY_KEYS } from '@/api/queries/activity';
import type { PaginatedLikersResponse } from '@/types/feed';
import { useInfiniteQuery } from '@tanstack/react-query';

export function useCheckInLikers(checkInId: string, enabled: boolean) {
  return useInfiniteQuery({
    queryKey: [...FEED_QUERY_KEYS.all, 'likers', checkInId],
    queryFn: async ({ pageParam }): Promise<PaginatedLikersResponse> => {
      return getCheckInLikers(checkInId, { page: pageParam });
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined,
    enabled,
    staleTime: 1000 * 30,
  });
}
